import { TranslateString } from "../types";

export const setPageTitle = (items: TranslateString[]) => {
  document.title = items.join(" | ");
};
